// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --color-primary: #0054E6;
  --color-primary-30: #003DAB;
  --color-white: #fff;

  --color-secondary: #C8D3FF;
  --color-secondary-100: #EFF2FF;
  --color-error: #BD0048;
  --color-secondary-error: #ffbdbd;
  --color-title: #6F879C;
  --color-text: #6f879c70;
  --color-text-item-column: #516372;
  --color-text-grey: #90909A;
  --color-text-grey-30: #767680;
  --color-text-light: #E2E1EC;
  --color-border: #C6C5D0;
  --color-background: #fff;
  --color-hover: #e7eaf067;
  --color-violet-light: #C7BFFF;
}`, "",{"version":3,"sources":["webpack://./src/app/providers/theme/colors.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,2BAA2B;EAC3B,mBAAmB;;EAEnB,0BAA0B;EAC1B,8BAA8B;EAC9B,sBAAsB;EACtB,gCAAgC;EAChC,sBAAsB;EACtB,uBAAuB;EACvB,iCAAiC;EACjC,0BAA0B;EAC1B,6BAA6B;EAC7B,2BAA2B;EAC3B,uBAAuB;EACvB,wBAAwB;EACxB,wBAAwB;EACxB,6BAA6B;AAC/B","sourcesContent":[":root {\r\n  --color-primary: #0054E6;\r\n  --color-primary-30: #003DAB;\r\n  --color-white: #fff;\r\n\r\n  --color-secondary: #C8D3FF;\r\n  --color-secondary-100: #EFF2FF;\r\n  --color-error: #BD0048;\r\n  --color-secondary-error: #ffbdbd;\r\n  --color-title: #6F879C;\r\n  --color-text: #6f879c70;\r\n  --color-text-item-column: #516372;\r\n  --color-text-grey: #90909A;\r\n  --color-text-grey-30: #767680;\r\n  --color-text-light: #E2E1EC;\r\n  --color-border: #C6C5D0;\r\n  --color-background: #fff;\r\n  --color-hover: #e7eaf067;\r\n  --color-violet-light: #C7BFFF;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
